import * as React from 'react';
import {
  Asset,
  AlabamaIcon,
  AlaskaIcon,
  ArizonaIcon,
  ArkansasIcon,
  CaliforniaIcon,
  ColoradoIcon,
  ConnecticutIcon,
  DelawareIcon,
  FloridaIcon,
  GeorgiaIcon,
  HawaiiIcon,
  IdahoIcon,
  IllinoisIcon,
  IndianaIcon,
  IowaIcon,
  KansasIcon,
  KentuckyIcon,
  LouisianaIcon,
  MaineIcon,
  MarylandIcon,
  MassachusettsIcon,
  MichiganIcon,
  MinnesotaIcon,
  MississippiIcon,
  MissouriIcon,
  MontanaIcon,
  NebraskaIcon,
  NevadaIcon,
  NewHampshireIcon,
  NewJerseyIcon,
  NewMexicoIcon,
  NewYorkIcon,
  NorthCarolinaIcon,
  NorthDakotaIcon,
  OhioIcon,
  OklahomaIcon,
  OregonIcon,
  PennsylvaniaIcon,
  RhodeIslandIcon,
  SouthCarolinaIcon,
  SouthDakotaIcon,
  TennesseeIcon,
  TexasIcon,
  UtahIcon,
  VermontIcon,
  VirginiaIcon,
  WashingtonIcon,
  WestVirginiaIcon,
  WisconsinIcon,
  WyomingIcon,
  AssetProps,
} from '@clearcover/atlas';

export const StateIcons = {
  AL: AlabamaIcon,
  AK: AlaskaIcon,
  AZ: ArizonaIcon,
  AR: ArkansasIcon,
  CA: CaliforniaIcon,
  CO: ColoradoIcon,
  CT: ConnecticutIcon,
  DE: DelawareIcon,
  FL: FloridaIcon,
  GA: GeorgiaIcon,
  HI: HawaiiIcon,
  ID: IdahoIcon,
  IL: IllinoisIcon,
  IN: IndianaIcon,
  IA: IowaIcon,
  KS: KansasIcon,
  KY: KentuckyIcon,
  LA: LouisianaIcon,
  ME: MaineIcon,
  MD: MarylandIcon,
  MA: MassachusettsIcon,
  MI: MichiganIcon,
  MN: MinnesotaIcon,
  MS: MississippiIcon,
  MO: MissouriIcon,
  MT: MontanaIcon,
  NE: NebraskaIcon,
  NV: NevadaIcon,
  NH: NewHampshireIcon,
  NJ: NewJerseyIcon,
  NM: NewMexicoIcon,
  NY: NewYorkIcon,
  NC: NorthCarolinaIcon,
  ND: NorthDakotaIcon,
  OH: OhioIcon,
  OK: OklahomaIcon,
  OR: OregonIcon,
  PA: PennsylvaniaIcon,
  RI: RhodeIslandIcon,
  SC: SouthCarolinaIcon,
  SD: SouthDakotaIcon,
  TN: TennesseeIcon,
  TX: TexasIcon,
  UT: UtahIcon,
  VT: VermontIcon,
  VA: VirginiaIcon,
  WA: WashingtonIcon,
  WV: WestVirginiaIcon,
  WI: WisconsinIcon,
  WY: WyomingIcon,
} as const;

export type StateVariant = keyof typeof StateIcons;

export const isStateAssetVariant = (
  stateVariant: string
): stateVariant is StateVariant => {
  return StateIcons.hasOwnProperty(stateVariant);
};

interface Props extends Omit<AssetProps, 'icon'> {
  stateVariant: StateVariant;
}

export const StateAsset: React.FC<Props> = ({
  stateVariant,
  ...restOfProps
}) => {
  return <Asset {...restOfProps} icon={StateIcons[stateVariant]} />;
};
